<div class="drawer"
  [ngClass]="{'drawer--hide-arrows': (storyChapters$ | async)?.length === 1 }">
  <div 
    class="drawer__arrow drawer__arrow--previous"
    [ngClass]="{'drawer__arrow--disabled': chapterIndex === 0}"
    (click)="handlePreviousClick()">
    <fa-icon icon="angle-left"></fa-icon>
  </div>

  <div 
    class="drawer__item" 
    (click)="handleChapterClick()">
    <div class="drawer__title">
      {{ (selectedChapter$ | async)?.info.displayName }}
    </div>

    <div class="drawer__description" [innerHTML]='(selectedChapter$ | async)?.info.description'></div>
  </div>

  <div 
    class="drawer__arrow drawer__arrow--next drawer__arrow--disabled"
    [ngClass]="{'drawer__arrow--disabled': chapterIndex === (storyChapters$ | async)?.length - 1}"
    (click)="handleNextClick()">
    <fa-icon icon="angle-right"></fa-icon>
  </div>
</div>
